<!-- src/UnderMaintenance.vue -->

<template>
  <div class="maintenance-page">
    <h1 class="maintenance-heading">Under Maintenance</h1>
  </div>
</template>

<script>
export default {
  name: 'UnderMaintenance',
};
</script>

<style scoped>
.maintenance-page {
  min-height: 100vh;
  width: 100%;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  box-sizing: border-box;
}

.maintenance-heading {
  margin: 0;
  color: #2ecc71;
  text-align: center;
  font-size: clamp(1.75rem, 8vw, 3.5rem);
  word-break: break-word;
}
</style>
